const ONBOARDING_PAGE = {
  BOTI_INTRO: 'botiIntro',
  YAHAV_IS_BACK: 'yahavIsBack',
  PROGRESS_INDICATION_1: 'progressIndication1',
  PROGRESS_INDICATION_2: 'progressIndication2',
  PREPARING_CASHFLOW: 'preparingCashflow',
  CASHFLOW_INTRO_INFORMATION: 'cashflowIntroInformation',
  FORWARD_LOOKING_INFORMATION: 'forwardLookingInformation',
  OSH_BALANCE_INFORMATION: 'oshBalanceInformation',
  SECURITY_INFORMATION: 'securityInformation',
  PREPARE_CREDENTIALS: 'prepareCredentials',
  BANK_DETAILS: 'bankDetails',
  DISCOUNT_INCOMPLETE: 'discountIncomplete',
  OBK_PARTIALLY_AUTHORIZED: 'partiallyAuthorised',
  INCOME_INVESTIGATION: 'incomeInvestigation',
  CREDIT_CARD_DETAILS: 'creditCardDetails',
  EXPENSE_INVESTIGATION: 'expenseInvestigation',
  CASHFLOW: 'cashflow',
  PAST_MONTH: 'pastMonth',
};

export default {
  ONBOARDING_PAGE,
};
